import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useMatch } from "react-router-dom";

const ClientDocumentTitle = ({ isAuthenticated }) => {
  const match = useMatch("/:page/:clientId/:caseId/*");
  const clientId = match?.params.clientId;
  const caseId = match?.params.caseId;
  const client = useSelector((state) => {
    if (!isAuthenticated) return null;

    const caseClient = state.caseData?.current?.for_client;
    const clients = [
      state.headerData?.headerSummary?.client_data,
      state.client?.current,
      ...(Array.isArray(caseClient) ? caseClient : [caseClient]),
      state.caseData?.summary?.for_client,
    ];

    // The main tab can show the loaded case without client/case IDs in its URL.
    return clients.find((item) => item && (!clientId || String(item.id) === String(clientId)));
  });
  const caseType = useSelector((state) => {
    if (!isAuthenticated) return "";

    const cases = [
      state.caseData?.current,
      state.headerData?.headerSummary?.case_data,
      state.caseData?.summary,
    ];

    return cases
      .find(
        (item) => item && (!caseId || String(item.id) === String(caseId)) && item.case_type?.name
      )
      ?.case_type.name.trim();
  });
  const name =
    client?.entity_name?.trim() ||
    [client?.last_name, client?.first_name]
      .map((part) => part?.trim())
      .filter(Boolean)
      .join(", ");
  // Chrome collapses regular spaces in titles; nonbreaking spaces preserve all three.
  const title = name ? [name, caseType].filter(Boolean).join("\u00a0\u00a0\u00a0") : "Perfect Case";
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
};

export default ClientDocumentTitle;
